export function parseMediaId(raw) {
  if (raw == null || raw === "") return null;
  const asNumber = Number(raw);
  return Number.isFinite(asNumber) ? asNumber : raw;
}

export function reorderMediaIds(ids, fromIndex, toIndex) {
  const current = Array.isArray(ids) ? [...ids] : [];
  if (
    fromIndex < 0
    || toIndex < 0
    || fromIndex >= current.length
    || toIndex >= current.length
    || fromIndex === toIndex
  ) {
    return current;
  }
  const [item] = current.splice(fromIndex, 1);
  current.splice(toIndex, 0, item);
  return current;
}

export function moveMediaByOffset(ids, imageId, offset) {
  const current = Array.isArray(ids) ? [...ids] : [];
  const index = current.indexOf(imageId);
  if (index < 0 || !Number.isFinite(Number(offset)) || offset === 0) return current;
  return reorderMediaIds(current, index, index + Number(offset));
}

export function collectMediaCardRects(root, selectedIds) {
  if (!root || typeof root.querySelectorAll !== "function") return [];
  const selected = new Set(Array.isArray(selectedIds) ? selectedIds : []);
  return Array.from(root.querySelectorAll("[data-media-id]"))
    .map((node) => {
      const id = parseMediaId(node.getAttribute("data-media-id"));
      if (id == null || !selected.has(id)) return null;
      if (typeof node.getBoundingClientRect !== "function") return null;
      const rect = node.getBoundingClientRect();
      if (!rect) return null;
      return {
        id,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        bottom: rect.bottom,
      };
    })
    .filter(Boolean);
}

export function resolveMediaDropTargetId({ clientX, clientY, fromId, rects }) {
  if (fromId == null) return null;
  let hitId = null;
  let hitArea = Infinity;
  (Array.isArray(rects) ? rects : []).forEach((item) => {
    if (!item || item.id === fromId) return;
    if (
      clientX >= item.left
      && clientX <= item.right
      && clientY >= item.top
      && clientY <= item.bottom
    ) {
      const width = Math.max(0, item.right - item.left);
      const height = Math.max(0, item.bottom - item.top);
      const area = width * height;
      if (area > 0 && area < hitArea) {
        hitArea = area;
        hitId = item.id;
      }
    }
  });
  return hitId;
}

export function resolveMediaIdFromPoint(clientX, clientY, excludeId) {
  if (typeof document === "undefined") return null;
  let hits = [];
  if (typeof document.elementsFromPoint === "function") {
    const stacked = document.elementsFromPoint(clientX, clientY);
    hits = Array.isArray(stacked) ? stacked : [];
  } else if (typeof document.elementFromPoint === "function") {
    const hit = document.elementFromPoint(clientX, clientY);
    hits = hit ? [hit] : [];
  }
  for (let index = 0; index < hits.length; index += 1) {
    const hit = hits[index];
    if (!hit || typeof hit.closest !== "function") continue;
    const card = hit.closest("[data-media-id]");
    if (!card) continue;
    const id = parseMediaId(card.getAttribute("data-media-id"));
    if (id == null || id === excludeId) continue;
    return id;
  }
  return null;
}
